import Api from '../api';
import {
  BackendChatMessage,
  ReorderChat,
  ReorderWorksheetActivity,
} from './types/reorder-chat';

const REORDER_CHAT = '/reorder-chat';

const ReorderChatAPI = {
  /**
   * Get the ReorderChat entity (with fn_contacts and vendor_contacts).
   * Backend proxies the request to po-service.
   * GET /users/:userId/reorder-chat/:styleColor/chat
   */
  getChat(userId: string, styleColor: string): Promise<ReorderChat | null> {
    return Api.get(
      `/users/${userId}${REORDER_CHAT}/${encodeURIComponent(styleColor)}/chat`,
    );
  },

  /**
   * Get chat messages for a reorder chat conversation.
   * Backend fetches messages from Twilio via chat-service.
   * GET /users/:userId/reorder-chat/:styleColor/messages
   */
  getChatMessages(
    userId: string,
    styleColor: string,
  ): Promise<BackendChatMessage[]> {
    return Api.get(
      `/users/${userId}${REORDER_CHAT}/${encodeURIComponent(styleColor)}/messages`,
    );
  },

  /**
   * Get activities for a reorder chat (OPEN_CHAT, CLOSE_CHAT, UPDATE_FORM).
   * Backend resolves vendorId internally from the authenticated vendor.
   * GET /users/:userId/reorder-chat/:styleColor/activities
   */
  getActivities(
    userId: string,
    styleColor: string,
  ): Promise<ReorderWorksheetActivity[]> {
    return Api.get(
      `/users/${userId}${REORDER_CHAT}/${encodeURIComponent(styleColor)}/activities`,
    );
  },
};

export default ReorderChatAPI;
